import { Icon } from "@components/icon";
import { LinkWithConfirm } from "@components/link_with_confirm/link_with_confirm";
import * as types from "@root/types";
import cx from "classnames";
import React, { type FC, useMemo } from "react";

interface PressItemListProps {
  pressItems: types.PressItemModel[];
}

interface PressItemRowProps {
  item: types.PressItemModel;
}

const PressItemRow: FC<PressItemRowProps> = ({ item }) => {
  const { link, id, tagline, source, publishedDate } = item;

  const deleteLink = (
    <LinkWithConfirm
      className="delete_link"
      confirmMessage="Are you sure you want to delete this press item"
      href={`/admin/press/${id}/delete`}
      title="Delete"
    >
      <Icon name="bin2" />
    </LinkWithConfirm>
  );

  const editLink = (
    <a href={`/admin/press/${id}/edit`} aria-label="edit" title="Edit">
      <Icon name="pencil" />
    </a>
  );
  return (
    <tr>
      <td>{tagline}</td>
      <td>{link ? <a href={link}>{link}</a> : null}</td>
      <td>{source}</td>
      <td className="table-cell--date">{publishedDate}</td>
      <td className="ctrls">
        <div className="actions">
          {editLink}
          {deleteLink}
        </div>
      </td>
    </tr>
  );
};

const PressItemsList: FC<PressItemListProps> = ({ pressItems }) => {
  const rows = useMemo(() => {
    if (!pressItems) {
      return null;
    }
    return pressItems.map((item) => <PressItemRow item={item} key={item.id} />);
  }, [pressItems]);

  return (
    <table className={cx("press-item-list", "admin-table", "striped")}>
      <thead>
        <tr>
          <th scope="col">Tagline</th>
          <th scope="col">Link</th>
          <th scope="col">Source</th>
          <th scope="col">Published Date</th>
          <th className="ctrls" scope="col"></th>
        </tr>
      </thead>
      <tbody>{rows}</tbody>
    </table>
  );
};
export { PressItemsList };
